import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardLayout from '@/components/feature/DashboardLayout';
import PageHeader from '@/components/feature/PageHeader';
import Button from '@/components/base/Button';
import Input from '@/components/base/Input';
import { useAppData } from '@/store/AppDataContext';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { drivers, resetDriverPassword } = useAppData();
  const driver = drivers.find((d) => d.id === id);

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');

  const submit = () => {
    if (!password.trim()) { setError('كلمة المرور الجديدة مطلوبة'); return; }
    if (password !== confirm) { setError('كلمتا المرور غير متطابقتين'); return; }
    resetDriverPassword(id || '');
    navigate('/drivers', {
      state: { toast: { type: 'success', message: `تم إعادة تعيين كلمة مرور ${driver?.name || 'المندوب'}` } },
    });
  };

  if (!driver) {
    return (
      <DashboardLayout title="إعادة تعيين كلمة المرور">
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <i className="ri-user-unfollow-line text-5xl text-foreground-300" aria-hidden="true"></i>
          <p className="mt-4 text-foreground-500">لم يتم العثور على المندوب</p>
          <button
            type="button"
            onClick={() => navigate('/drivers')}
            className="mt-4 text-[13px] font-medium text-secondary-600 hover:text-secondary-700"
          >
            العودة للمندوبين
          </button>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout title="إعادة تعيين كلمة المرور">
      <div className="mx-auto w-full max-w-[480px]">
        <PageHeader
          title={`إعادة تعيين كلمة مرور: ${driver.name}`}
          subtitle="المندوب سيحتاج تسجيل الدخول بكلمة المرور الجديدة في التطبيق."
          backTo="/drivers"
        />

        <div className="rounded-card border border-background-200 bg-white p-5 shadow-card">
          <div className="flex items-center gap-3 border-b border-background-100 pb-4 mb-4">
            <div className="h-12 w-12 overflow-hidden rounded-full border border-background-200 shrink-0">
              <img src={driver.photo} alt={driver.name} className="h-full w-full object-cover object-top" />
            </div>
            <div>
              <p className="font-semibold text-[15px] text-foreground-950">{driver.name}</p>
              <p className="text-[12px] text-foreground-400" dir="ltr">{driver.phone}</p>
            </div>
          </div>

          <div className="space-y-4">
            <Input
              label="كلمة المرور الجديدة"
              name="newPassword"
              type="password"
              value={password}
              onChange={(event) => { setPassword(event.target.value); setError(''); }}
              placeholder="••••••••"
            />
            <Input
              label="تأكيد كلمة المرور"
              name="confirmPassword"
              type="password"
              value={confirm}
              onChange={(event) => { setConfirm(event.target.value); setError(''); }}
              placeholder="••••••••"
              error={error}
            />
            <div className="flex items-center gap-1.5 rounded-lg bg-accent-50 px-3 py-2.5 text-[12px] text-accent-800">
              <i className="ri-information-line text-[14px]" aria-hidden="true"></i>
              المندوب سيحتاج تسجيل الدخول بكلمة المرور الجديدة في التطبيق.
            </div>
          </div>

          <div className="mt-6 flex flex-col gap-3 border-t border-background-100 pt-5 sm:flex-row">
            <Button variant="outline" size="lg" className="flex-1" onClick={() => navigate('/drivers')}>
              إلغاء
            </Button>
            <Button variant="cta" size="lg" className="flex-1" icon="ri-lock-password-line" onClick={submit}>
              تعيين كلمة المرور
            </Button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}